import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { ChevronLeftIcon } from "@graphiql/react";
import { Kind, isObjectType, isInterfaceType } from "graphql";
import { findDefinition } from "../lib/ast-path.js";
import { FieldTree } from "./field-tree.js";
const FragmentEditor = (t0) => {
  const $ = c(38);
  const {
    fragmentName,
    doc,
    schema,
    target,
    cursorPath,
    onBack,
    onToggle,
    onSetArg,
    onAddInlineFragment,
    onRemoveInlineFragment,
    onRemoveFragmentSpread,
    onExtractFragment,
    onRenameFragment,
    onFocusFragment
  } = t0;
  let rootType;
  let t1;
  let typeName;
  if ($[0] !== doc || $[1] !== schema || $[2] !== target) {
    const definition = findDefinition(doc, target);
    typeName = (definition == null ? void 0 : definition.kind) === Kind.FRAGMENT_DEFINITION ? definition.typeCondition.name.value : void 0;
    rootType = typeName ? schema.getType(typeName) : void 0;
    t1 = rootType != null && (isObjectType(rootType) || isInterfaceType(rootType));
    $[0] = doc;
    $[1] = schema;
    $[2] = target;
    $[3] = rootType;
    $[4] = t1;
    $[5] = typeName;
  } else {
    rootType = $[3];
    t1 = $[4];
    typeName = $[5];
  }
  const editable = t1;
  let t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /* @__PURE__ */ jsx(ChevronLeftIcon, {});
    t3 = /* @__PURE__ */ jsx("span", { children: "Back to query" });
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  let t4;
  if ($[8] !== onBack) {
    t4 = /* @__PURE__ */ jsxs("button", { type: "button", className: "graphiql-qb-fragment-back", onClick: onBack, "aria-label": "Back to query", children: [
      t2,
      t3
    ] });
    $[8] = onBack;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== fragmentName) {
    t5 = /* @__PURE__ */ jsxs("span", { className: "graphiql-qb-fragment-editor-heading", children: [
      "Editing",
      " ",
      /* @__PURE__ */ jsx("span", { className: "graphiql-qb-fragment-editor-name", children: fragmentName }),
      " ",
      "fragment"
    ] });
    $[10] = fragmentName;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== typeName) {
    t6 = typeName && /* @__PURE__ */ jsxs("span", { className: "graphiql-qb-fragment-editor-type", children: [
      "on ",
      typeName
    ] });
    $[12] = typeName;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = /* @__PURE__ */ jsxs("div", { className: "graphiql-qb-fragment-editor-title", children: [
      t5,
      t6
    ] });
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t4 || $[18] !== t7) {
    t8 = /* @__PURE__ */ jsxs("div", { className: "graphiql-qb-fragment-editor-header", children: [
      t4,
      t7
    ] });
    $[17] = t4;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== cursorPath || $[21] !== doc || $[22] !== editable || $[23] !== onAddInlineFragment || $[24] !== onExtractFragment || $[25] !== onFocusFragment || $[26] !== onRemoveFragmentSpread || $[27] !== onRemoveInlineFragment || $[28] !== onRenameFragment || $[29] !== onSetArg || $[30] !== onToggle || $[31] !== rootType || $[32] !== schema || $[33] !== target) {
    t9 = editable ? /* @__PURE__ */ jsx(FieldTree, { type: rootType, path: [], doc, schema, target, cursorPath, onToggle, onSetArg, onAddInlineFragment, onRemoveInlineFragment, onRemoveFragmentSpread, onExtractFragment, onRenameFragment, onFocusFragment }) : /* @__PURE__ */ jsx("p", { className: "graphiql-qb-empty", children: "This fragment’s type has no editable fields." });
    $[20] = cursorPath;
    $[21] = doc;
    $[22] = editable;
    $[23] = onAddInlineFragment;
    $[24] = onExtractFragment;
    $[25] = onFocusFragment;
    $[26] = onRemoveFragmentSpread;
    $[27] = onRemoveInlineFragment;
    $[28] = onRenameFragment;
    $[29] = onSetArg;
    $[30] = onToggle;
    $[31] = rootType;
    $[32] = schema;
    $[33] = target;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  let t10;
  if ($[35] !== t8 || $[36] !== t9) {
    t10 = /* @__PURE__ */ jsxs("section", { className: "graphiql-qb-fragment-editor", "aria-label": "Fragment editor", children: [
      t8,
      t9
    ] });
    $[35] = t8;
    $[36] = t9;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  return t10;
};
export {
  FragmentEditor
};
//# sourceMappingURL=fragment-editor.js.map
